export default __webpack_public_path__ + "static/media/Web.c71e3312.svg";